// CtaBox.js
import React from "react";

const CtaBox = () => {
  return (
    <div className="cta-box bg-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-7">
            {/* Cta Box Content Start */}
            <div className="cta-box-content">
              {/* Section Title Start */}
              <div className="section-title">
                <h2 className="text-anime-style-3" data-cursor="-opaque">
                  Travel with comfort & reliability — Book with Aaryan Travels!
                </h2>
                <p className="wow fadeInUp">
                  Whether it’s a corporate transfer, airport drop, or an
                  all-India trip, <strong>Aaryan Travels</strong> ensures a
                  premium and hassle-free travel experience. Our support team is
                  available 24/7 to assist you with bookings and inquiries.
                </p>
              </div>
              {/* Section Title End */}

              {/* Cta Box Btn Start */}
              <div className="cta-box-.vision-mission-list ul li wow fadeInUp ctbtn" data-wow-delay="0.5s">
                <a href="/contact-us" className="btn-default">
                  Contact Us
                </a>
              </div>
              {/* Cta Box Btn End */}
            </div>
            {/* Cta Box Content End */}
          </div>

          <div className="col-lg-6 col-md-5">
            {/* Cta Box Image Start */}
            <div className="cta-box-image">
              <figure>
                <img src="/images/gallery/luxury/bmw-5series.png" alt="Aaryan Travels Car" />
                {/* <img src="images/cta-car-img.png" alt="Aaryan Travels Car" /> */}
              </figure>
            </div>
            {/* Cta Box Image End */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CtaBox;
